import React, { useEffect } from 'react';

import { BiCaretUp, BiCaretDown } from 'react-icons/bi';

import {
  BsFillCheckCircleFill,
  BsClockFill,
  BsDashCircleFill,
  BsFillXCircleFill,
} from 'react-icons/bs';
import { userStatus } from '../../enums/userStatus';
import { colorStatus } from '../../constant/constant';

import './select.css';

const Select: React.FC<any> = ({ loginUserStatus, setLoginUserStatus }) => {
  const handleChangeStatus = (newStatus: number): void => {
    setLoginUserStatus(newStatus);
    localStorage.setItem('@LiveChat:userStatus', newStatus.toString());
  };

  useEffect(() => {
    const select = document.querySelector('.select');
    const selectedValue = document.getElementById('selected-value');
    const selectedValueSvg = document.getElementById('selected-value-svg');
    const optionsViewButton = document.getElementById('options-view-button');
    const inputsOptions = document.querySelectorAll('.option input');

    const handleInputChange = (event: any): void => {
      if (selectedValue === null || selectedValueSvg === null) {
        return;
      }

      selectedValue.textContent = event.target.dataset.label;

      const isMouseOrTouch =
        event.pointerType === 'mouse' || event.pointerType === 'touch';
      if (isMouseOrTouch) optionsViewButton?.click();
    };

    inputsOptions.forEach((input) => {
      input.addEventListener('click', handleInputChange);

      // Certifique-se de remover os event listeners quando o componente é desmontado
      return () => {
        input.removeEventListener('click', handleInputChange);
      };
    });

    const userStatusAtual = localStorage.getItem('@LiveChat:userStatus');

    if (userStatusAtual !== null) {
      setLoginUserStatus(Number(userStatusAtual));
      if (selectedValueSvg != null) {
        selectedValueSvg.style.color = colorStatus[Number(userStatusAtual)];
      }

      inputsOptions.forEach((input: any) => {
        if (input.value === userStatusAtual) {
          handleInputChange({
            target: { dataset: { label: input.dataset.label } },
          });
        }
      });
    } else {
      setLoginUserStatus(userStatus.Online);
      localStorage.setItem(
        '@LiveChat:userStatus',
        userStatus.Online.toString()
      );
    }

    // Certifique-se de remover os event listeners quando o componente é desmontado
    return () => {
      inputsOptions.forEach((input) => {
        input.removeEventListener('click', handleInputChange);
      });
    };
  }, []);

  function getStatusIcon(): JSX.Element {
    if (loginUserStatus === userStatus.Online) {
      return (
        <BsFillCheckCircleFill
          color="#198754"
          id="selected-value-svg"
          className="me-2"
          style={{ height: '1.25rem', width: '1.25rem' }}
        />
      );
    }
    if (loginUserStatus === userStatus.Ausente) {
      return (
        <BsClockFill
          color="#ffc107"
          id="selected-value-svg"
          className="me-2"
          style={{ height: '1.25rem', width: '1.25rem' }}
        />
      );
    }
    if (loginUserStatus === userStatus.Ocupado) {
      return (
        <BsDashCircleFill
          color="#dc3545"
          id="selected-value-svg"
          className="me-2"
          style={{ height: '1.25rem', width: '1.25rem' }}
        />
      );
    }
    return (
      <BsFillXCircleFill
        color="#000"
        id="selected-value-svg"
        className="me-2"
        style={{ height: '1.25rem', width: '1.25rem' }}
      />
    );
  }

  return (
    <div className="select">
      <div id="category-select">
        {/* eslint-disable jsx-a11y/label-has-associated-control */}
        <input type="checkbox" id="options-view-button" />
        <div id="select-button">
          <div className="d-flex align-items-center">
            {getStatusIcon()}
            <label id="selected-value">online</label>
          </div>

          <div id="chevrons">
            <BiCaretDown
              data-lucide="chevron-down"
              style={{ height: '1.25rem', width: '1.25rem' }}
            />
            <BiCaretUp
              data-lucide="chevron-up"
              style={{ height: '1.25rem', width: '1.25rem' }}
            />
          </div>
        </div>
      </div>

      <ul id="options">
        <li className="option">
          <input
            type="radio"
            name="category"
            value={userStatus.Online}
            onClick={() => handleChangeStatus(userStatus.Online)}
            data-label="online"
          />
          <BsFillCheckCircleFill
            color="#198754"
            style={{ height: '1.25rem', width: '1.25rem' }}
          />
          <span className="label">online</span>
        </li>

        <li className="option">
          <input
            type="radio"
            name="category"
            value={userStatus.Ausente}
            onClick={() => handleChangeStatus(userStatus.Ausente)}
            data-label="ausente"
          />
          <BsClockFill
            color="#ffc107"
            style={{ height: '1.25rem', width: '1.25rem' }}
          />
          <span className="label">ausente</span>
        </li>

        <li className="option">
          <input
            type="radio"
            name="category"
            value={userStatus.Ocupado}
            onClick={() => handleChangeStatus(userStatus.Ocupado)}
            data-label="ocupado"
          />
          <BsDashCircleFill
            color="#dc3545"
            style={{ height: '1.25rem', width: '1.25rem' }}
          />
          <span className="label">ocupado</span>
        </li>

        <li className="option">
          <input
            type="radio"
            name="category"
            value={userStatus.Invisivel}
            onClick={() => handleChangeStatus(userStatus.Invisivel)}
            data-label="invisível"
          />
          <BsFillXCircleFill
            color="#000"
            style={{ height: '1.25rem', width: '1.25rem' }}
          />
          <span className="label">invisível</span>
        </li>
      </ul>
    </div>
  );
};

export default Select;
